<template>
  <ThemeProvider>
    <SidebarProvider>
      <RouterView />
    </SidebarProvider>
  </ThemeProvider>
</template>

<script setup lang="ts">
import ThemeProvider from './components/layout/ThemeProvider.vue'
import SidebarProvider from './components/layout/SidebarProvider.vue'
import { onMounted } from 'vue'
import { userSignOut } from './services/auth'
import { getUserToken } from './utils/localStorage'

function decodeJWT(token: string) {
  const parts = token.split('.')

  if (parts.length !== 3) {
    throw new Error('Invalid JWT format')
  }

  // Decode the payload (second part)
  const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))

  // Optionally decode the header (first part)
  const header = JSON.parse(atob(parts[0].replace(/-/g, '+').replace(/_/g, '/')))

  return { header, payload }
}

onMounted(() => {
  try {
    // Initialize the auction API
    const token = getUserToken() // Assume this function retrieves the user's token
    const decoded = decodeJWT(token!)
    if (!decoded.payload.isAdmin) {
      userSignOut()
    }
  } catch (error) {}
})
</script>
